import { IAttachment } from "../../caseLawDocuments/model/Attachment";
import DeleteListResourceInteractor from "../../core/interactor/app/crud/DeleteListResourceInteractor";
import Constants from "../common/Constants";

export default class RemoveCaseDecisionAttachmentInteractor {
  private resource: DeleteListResourceInteractor<IAttachment>;

  constructor({ deleteListResource }: any) {
    this.resource = deleteListResource;
  }

  async execute(caseDecisionId: string, attachments: IAttachment[]) {
    return this.resource.execute(
      `${Constants.endpointBasePath}/${caseDecisionId}/${Constants.attachmentPath}`,
      attachments
    );
  }
}
